module.exports = __webpack_public_path__ + "img/logo6.ec9f7800.png";